import { motion } from "framer-motion";
import { Zap, ShieldCheck, Droplets, Leaf, Activity, Clock } from "lucide-react";

const advantages = [
  { icon: Zap, title: "Accelerated Closure", stat: "2×", desc: "Faster epithelial closure vs. standard dressings in internal trials.", span: "md:col-span-2" },
  { icon: ShieldCheck, title: "Antimicrobial Shield", stat: "99.9%", desc: "Barrier against common wound pathogens." },
  { icon: Droplets, title: "Moist Healing", stat: "72h", desc: "Sustained hydration for optimal tissue repair." },
  { icon: Leaf, title: "Bio-Compatible", stat: "0", desc: "Zero cytotoxicity — gentle on new tissue." },
  { icon: Activity, title: "Reduced Scarring", stat: "−40%", desc: "Lower visible scar formation on healed wounds.", span: "md:col-span-2" },
  { icon: Clock, title: "Long Protection", stat: "24h", desc: "Single application, all-day protective seal." },
];

export const Bioactives = () => (
  <section id="bioactives" className="py-24 md:py-32 relative" data-testid="bioactives-section">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="flex items-baseline gap-4 mb-12 max-w-2xl">
        <span className="font-serifaccent italic text-secondary text-6xl md:text-7xl leading-none">02</span>
        <div>
          <span className="font-monotech text-xs tracking-[0.25em] uppercase text-text-muted">Chapter</span>
          <h2 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight text-primary leading-none">
            Advantages of Bioactives
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
        {advantages.map((a, i) => {
          const Icon = a.icon;
          return (
            <motion.div
              key={a.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
              className={`${a.span || ""} group border border-border bg-card rounded-3xl p-7 hover:bg-primary transition-colors duration-400 hover:-translate-y-1 hover:shadow-xl`}
              data-testid={`bioactive-card-${i}`}
            >
              <div className="flex items-start justify-between">
                <div className="w-11 h-11 rounded-xl bg-muted grid place-items-center group-hover:bg-secondary transition-colors duration-400">
                  <Icon className="w-5 h-5 text-primary" />
                </div>
                <span className="font-heading font-extrabold text-4xl text-clinic group-hover:text-secondary transition-colors duration-400">
                  {a.stat}
                </span>
              </div>
              <h3 className="font-heading font-bold text-xl text-primary mt-6 group-hover:text-white transition-colors duration-400">
                {a.title}
              </h3>
              <p className="text-sm text-text-muted mt-2 group-hover:text-white/70 transition-colors duration-400">
                {a.desc}
              </p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
